"use client";

import type React from "react";
import cn from "clsx";
import { ChevronDownIcon } from "lucide-react";

interface ProfileButtonProps {
    onClick: () => void;
    type?: "profile" | "connect";
}

const ProfileButton: React.FC<ProfileButtonProps> = ({ onClick, type = "profile" }) => {
    return (
        <button
            className={cn(
                "overflow-hidden rounded-full border border-primary w-fit hover:bg-primary bg-primary/30 px-4 h-9 justify-between items-center flex",
            )}
            onClick={onClick}
        >
            {type === "connect" ? (
                <>
                    <span className="sm:hidden">Connect</span>
                    <span className="hidden sm:inline">Connect Wallet</span>
                </>
            ) : (
                <div className="flex justify-center items-center gap-2 w-full">
                    <span>Profile</span>
                    <ChevronDownIcon className="-me-1 opacity-60" size={16} aria-hidden="true" />
                </div>
            )}
        </button>
    );
};

export default ProfileButton;
